export class AssetModel {
    constructor({ id, name, brand, model, code, label, categoriaId }) {
        this.id= id;
        this.name= name;
        this.brand= brand;
        this.model= model;
        this.code= code;
        this.label = label;
        this.categoriaId = categoriaId;
    }
    static fromJson(json) {
        return new AssetModel({
            id: json.id,
            name: json.nome ?? json.descricao,
            brand: json.marca,
            model: json.modelo,
            code: json.codigo,
            categoriaId: json.categoria_id,
            label: `${json.codigo} - ${json.nome ?? json.descricao}`
        });
    }
}
